import { AUCTION_URL } from '@/constants/common';
import { getEntityId } from '@/utils';

/** Public auction (bidding) page of the property in the auction app. */
export const getAuctionUrl = (propertyId?: string) => {
  const entityId = getEntityId(propertyId ?? '');

  if (!AUCTION_URL || !entityId) return '';

  return `${AUCTION_URL.replace(/\/+$/, '')}/${entityId}/bud`;
};
